module.exports = __webpack_public_path__ + "static/tmm3-17d122b74b6f582f941ccd350cbf2db1.png";